// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import AddForm from "./addForm";
import List from "./list";
import UpdateForm from "./updateForm";

import { IAlbumProps } from "./common";
import { useAuth } from "./hooks";
import PermissionHelper from "../../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const Album: FunctionComponent<IAlbumProps> = ({ menuIndex }) => {
  // ---------------------------------------------- router state
  let match = useRouteMatch();

  // ---------------------------------------------- local state
  const { profile, areLoaded, isEmptied } = useAuth();

  // ---------------------------------------------- content
  return !areLoaded ? null : isEmptied ||
    !match ||
    !PermissionHelper.getView(profile.permissions, menuIndex) ? (
    <Redirect to="/login" />
  ) : (
    <>
      <Route
        exact
        path={match.path}
        render={props => <List {...props} menuIndex={menuIndex}></List>}
      />

      <Switch>
        <Route
          exact
          path={`${match.path}/add`}
          render={props => <AddForm {...props} menuIndex={menuIndex}></AddForm>}
        />

        <Route
          exact
          path={`${match.path}/update/:album_id`}
          render={props => (
            <UpdateForm {...props} menuIndex={menuIndex}></UpdateForm>
          )}
        />
      </Switch>
    </>
  );
};

export default Album;
